<template>
  <v-container>
    <runner-form schema="new" title="NUEVO CORREDOR" />
  </v-container>
</template>

<script>
import RunnerForm from "../../components/Forms/RunnerForm.vue";
export default {
  components: { RunnerForm },
};
</script>

<style></style>
